

const NewsHeader:React.FC = () => {
    
    return (
        <header className="w-full uppercase text-white font-bold text-center pb-20 pt-28 text-5xl">Avirbhaav</header>
    );
}
 
export default NewsHeader;